import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function FinalClose() {
  return <section className="w-full bg-[#0f172a] pb-24 px-4 text-center border-t border-[#1e293b]" data-id="element-87">
      <div className="max-w-2xl mx-auto pt-16" data-id="element-88">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-89">
          <p className="text-xl md:text-2xl text-[#cbd5e1] mb-8 font-light leading-relaxed" data-id="element-90">
            Si hoy estás funcionando con café, lágrimas y suerte… <br data-id="element-91" />
            no necesitas más información.
          </p>

          <p className="text-xl md:text-2xl text-[#cbd5e1] mb-12 font-light" data-id="element-92">
            Necesitas un plan que se pueda ejecutar sin pensar.
          </p>

          <h3 className="font-serif text-2xl md:text-4xl font-bold text-white mb-12 leading-tight" data-id="element-93">
            A las 2AM No Se Estudia. <br data-id="element-94" />
            <span className="text-[#5b8a7a]" data-id="element-95">A las 2AM Se Sigue un Guion.</span>
          </h3>

          <motion.a href="https://www.betterbysteps.com/cart/44204964905053:1" target="_blank" rel="noopener noreferrer" whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="inline-flex mx-auto bg-[#e8856c] text-white px-10 py-4 rounded-xl text-base font-bold shadow-[0_0_25px_rgba(232,133,108,0.4)] hover:shadow-[0_0_35px_rgba(232,133,108,0.6)] transition-all items-center justify-center gap-2 no-underline" data-id="element-96">
            Obtener Acceso Inmediato
            <ArrowRight className="w-5 h-5" data-id="element-97" />
          </motion.a>
          <p className="text-[#64748b] text-sm mt-4" data-id="element-98">
            Descarga inmediata · Garantía de satisfacción
          </p>
        </motion.div>
      </div>
    </section>;
}